import { IconBuildingCommunity } from "@tabler/icons-react"
import { CitySelect } from "@/components/forms"
import type { TQuestionProps } from "./types"

export function QuestionCity({ setValue, value: initial }: TQuestionProps) {
  const value = initial

  return (
    <CitySelect
      size="lg"
      maw={400}
      leftSection={<IconBuildingCommunity />}
      value={value ? value.toString() : null}
      onChange={(value) => setValue(value ? parseInt(value, 10) : null)}
    />
  )
}
